import { Link } from '@/i18n/navigation';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import logoHorizontal from '/public/images/logo-horizontal.svg';
import { AppDownloadButton } from './AppDownloadButton';

type GlobalHeaderProps = {
  className?: string;
};

export function GlobalHeader({ className }: GlobalHeaderProps) {
  const t = useTranslations('common');

  return (
    <header
      className={clsx(
        'flex items-center justify-between px-6 h-14 border-b-thin border-b-neutral-auxiliary bg-base-ground z-navigation-top',
        className
      )}
    >
      <div className="flex items-center">
        <Link
          aria-label={t('globalHeader.home')}
          href="/"
          className="relative mr-4 h-8 w-[216px] flex-none"
        >
          <Image alt={t('globalHeader.title')} src={logoHorizontal} fill />
        </Link>
        <p className="sp:hidden tab:hidden text-small font-bold">{t('globalHeader.title')}</p>
      </div>
      <AppDownloadButton className="hidden pc:block tab:block" />
    </header>
  );
}
